import React from 'react'
import pdfLogo from 'images/pdf-logo.png'
import Chart from '../../form/Chart'
import LimitedViewText from './LimitedViewText'

const Overview = ({
  category,
  limitedView,
  locations,
  photo
}) => {
  return (
    <React.Fragment>
      <section className="section" data-anchor="overview">
        <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box">
          <div>
            <div className="image-layer image-layer--black bg-center bg-cover bg-no-repeat relative" style={{ backgroundImage: `url('${photo[0].url}')` }}>
              <h2 className="persona-sub-title p4 relative sm-p3 text-white z1">Overview</h2>
            </div>

            <div className="fs-18 medium p4 sm-px0 sm-py3 x-lg-h4">
              <div className="flex flex-wrap mxn2">
                <div className="col-4 px2 sm-hide" />

                <div className="col-4 px2 sm-col-12 sm-mb3">
                  <div className="mb-20">
                    lussy.io gathered live data from consumers who are discussing your product category and who
                    intend to make a purchase related to your category.
                  </div>

                  <div>
                    Use this data to learn more about their interest, their media consumption behavior.
                    Enabling you to know who they are, what to tell them and how to reach them.
                  </div>
                </div>

                <div className="col-4 px2 sm-col-12">
                  <div className="border border-violet-red bw-2 p3 rounded-16">
                      <>
                        <b>Category:</b>
                        <br />
                        {category}
                        <br />
                        <br />

                        <b>Period:</b>
                        <br />
                        last 30 days
                        <br />
                        <br />

                        <b>Location:</b>
                        <br />
                        {locations.join(' - ')}
                      </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
};

export default Overview
